var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { Message as SemanticMessage } from 'semantic-ui-react';
import cn from 'classnames';
import MessageAction from './MessageAction';
const ExtendedMessage = (_a) => {
    var { action, children, className } = _a, rest = __rest(_a, ["action", "children", "className"]);
    return (React.createElement(SemanticMessage, Object.assign({ className: cn(className, {
            action,
        }) }, rest), children && (React.createElement(React.Fragment, null,
        action ? React.createElement(Message.Content, null, children) : children,
        action ? React.createElement(MessageAction, { label: action.label, handler: action.handler }) : null))));
};
ExtendedMessage.Action = MessageAction;
export const Message = hoistNonReactStatic(ExtendedMessage, SemanticMessage);
Message.displayName = 'Message';
export default Message;
//# sourceMappingURL=Message.js.map